import { Component, Vue } from 'vue-property-decorator';

@Component
export default class RenounceButton extends Vue {
  /**
   * Redirect the user to the alternative questionnaire
   */
  protected renounce(): void {
    this.$router.push({
      name: 'alternativeQuestionnaire',
      params: {
        screening: this.$route.params.screening,
        partId: String(this.$route.params.partId),
      },
    });
  }
}
